<div class="associated-panel-container">

    <div class="d-flex align-middle icon-and-title-section">
      <i class="ph ph-link-simple color-basic-500 me-1 d-flex justify-content-center"></i>
      <div class="d-flex flex-column gap-1 pb-4">
        <div class="panel-title fw-700 color-basic-800 text-limited-2-lines">
            {{panelTitle | uppercase}}
        </div>
        <div class="data-section">
          <ng-content></ng-content>
        </div>
        <!--Opening of external link into a new tab-->
        <a [href]="externalLinkUrl"
           target="_blank">
          <ex-button icon="arrow-square-out" type="secondary" variant="raised">
            {{externalLinkSectionTitle | translate }}
          </ex-button>
        </a>
      </div>
    </div>

</div>
